import React, { Component } from 'react'
import Box from '@mui/material/Box';
import colors from './Colors';
import Plot from 'react-plotly.js';
import './Styles/NFP.css'
import { DataGrid } from '@mui/x-data-grid';
import CsvDownload from 'react-json-to-csv'
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Table from "./Containers/Table";
import SplashScreen from './SplashScreen.tsx';
// import CsvDownload from "react-json-to-csv";

import { PureComponent } from 'react';
import { LineChart,  AreaChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;

const getPercent = (value, total) => {
  const ratio = total > 0 ? value / total : 0;

  return toPercent(ratio, 1);
};


const renderTooltipContent = (o) => {
  const { payload, label } = o;
  const total = payload.reduce((result, entry) => result + entry.value, 0);

  return (
    <div className="customized-tooltip-content">
      <p className="total">{`${label} (Total: ${total})`}</p>
      <ul className="list">
        {payload.map((entry, index) => (
          <li key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`}
          </li>
        ))}
      </ul>
    </div>
  );
};

export class CEO extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            active: false,
            addr:'',
            data:{
              count:0,
              sales:0,
            },
            data2:[],
            sales:{
              x:[],
              y:[],
            },
            bundle:{
              x:[],
              y:[],
            },
            trans:{
                row:[{}],
                column:[],
                transactions:0,
                mimShareAmount:0,
                paymentInit:0,
            },
            searchValue: '',
            searchdata:[],
            lock:false,
            done: [],
            id: sessionStorage.getItem('id') || '',
            secret: sessionStorage.getItem('authkey') || '',
            level: sessionStorage.getItem("level"),
            selectedrequests:[],
            totalamount:0,
            payi:true,
            payc:true,
            ins:"",
            re:"",
            payable:0,
            isFlipped:false,
            loadingii:false
        };
      }
    
      componentDidMount() {
        console.log('ddd');
        this.setState({loadingii:false})
        var addrr = "http://sfoadmin.myimpactmeter.com:5050/";
        fetch(addrr + "/ceo/impactor/insight")
          .then((response) => response.json())
          .then((data) => {
            this.setState({ data: data['data'],});
            console.log(this.state.data2)
            this.setState({ data2: data['data2'],})
          }
        );   
      }

 
 
  render() {
    return (
      <div className="allcontents" style={{'background-color':'#0A1929'}}>
          <h1  className="das-name">
            Impactor
          </h1>
          <div style={{ "padding-left":'20px', "padding-top":'-10px'  }} >
          <ResponsiveContainer width="95%" height={500}>
              <LineChart
                width={1000}
                height={500}
                data={this.state.data}
                margin={{
                  top: 15,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
                
                style={{ background: "rgba(255, 255, 255, 0.137)", borderRadius: '10px', padding:'20px' }}
              >
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <XAxis dataKey="date" tick={{ stroke: 'white', fontWeight:'10', fontSize:'10px' }} />
                <YAxis tick={{ stroke: 'white' }} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="registered" stroke="#8884d8" activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="verified" stroke="#82ca9d" />
                <Line type="monotone" dataKey="loginCount" stroke="#824e9d" />
                
              </LineChart>
              </ResponsiveContainer>
              
          </div>
          <h2 style={{ "padding-left":'20px', "padding-top":'40px', 'color':'white'  }} >Cummulative Stats of Impactor</h2>
          <div style={{ "padding-left":'20px', "padding-top":'-10px'  }} >
          <ResponsiveContainer width="95%" height={500}>
                <AreaChart
                width={500}
                height={400}
                data={this.state.data2}
                stackOffset="expand"
                margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
                }}
                style={{ background: "rgba(255, 255, 255, 0.137)", borderRadius: '10px', padding:'20px' }}
              >
                <XAxis dataKey="date"  tick={{ stroke: 'white' }}/>
                <YAxis tickFormatter={toPercent} tick={{ stroke: 'white' }} />
                <Legend />
                <Tooltip  />
                <Area type="monotone" dataKey="registered" stackId="1" stroke="#8884d8" fill="#8884d8" />
                <Area type="monotone" dataKey="verified" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                <Area type="monotone" dataKey="at least 1 transaction" stackId="1" stroke="#ffc658" fill="#ffc658" />
                <Area type="monotone" dataKey="more or equal to 4 transaction" stackId="1" stroke="red" fill="red" />
              </AreaChart>

            </ResponsiveContainer>
              
          </div>
          <h2 style={{ "padding-left":'20px', "padding-top":'40px', 'color':'white'  }} >Percentage Stats of Impactor every month and their Converstion</h2>
          <br></br>
        </div>

    )
  }
}

export default CEO